"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const provider_1 = require("@cart/provider");
const Delete_1 = require("@kawaui/icons/build/icons/action/Delete");
const cart_items_1 = require("../styles/cart-items");
const hooks_1 = require("../utils/hooks");
const mixpanel_1 = require("../utils/mixpanel");
const RemoveItemButton = ({ item, cartType }) => {
    const { removeItemFromCartConnected } = (0, provider_1.useCartActions)();
    const trackClick = (0, hooks_1.useCallbackTrackEvent)();
    const handleRemove = (event) => {
        event.stopPropagation();
        trackClick((0, mixpanel_1.FloatingCartClickDelete)(item));
        removeItemFromCartConnected(item.product_id, cartType);
    };
    return ((0, jsx_runtime_1.jsx)(cart_items_1.IconButton, { onClick: handleRemove, children: (0, jsx_runtime_1.jsx)(Delete_1.IconDelete, {}) }));
};
exports.default = RemoveItemButton;
